import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Assessment } from '@/models/Assessment';
import Evaluation from '@/models/Evaluation';
import { Nullable } from '@/models/Model';
import AssessmentFormService from './AssessmentFormService';
import EvaluationBlockList from './EvaluationBlockList';

export type AssessmentEditState = Nullable<{
  evaluation: Evaluation;
  assessment?: Assessment;
}>;

type EvaluationsTabContentProps = {
  courseLineId: number;
};

export default function EvaluationsTabContent({
  courseLineId,
}: EvaluationsTabContentProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.evaluationsTab',
  });

  const [editingState, setEditingState] = useState<AssessmentEditState>(null);

  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-lg font-semibold text-base-content">{t('title')}</h2>
      {editingState && (
        <AssessmentFormService
          evaluation={editingState.evaluation}
          assessment={editingState.assessment}
          courseLineId={courseLineId}
          onClose={() => setEditingState(null)}
        />
      )}
      <ConditionalRenderer condition={!editingState}>
        <EvaluationBlockList
          courseLineId={courseLineId}
          onEditingAssessment={setEditingState}
        />
      </ConditionalRenderer>
    </div>
  );
}
